<template>
    <div>
        <v-card class="p-3">
            <div class="d-flex justify-content-between">
                <v-radio
                  class="mr-5"
                  :value="source"
                  color="blue"
                  outlined>
                </v-radio>

                <div>
                    <div class="row">
                        <div class="col-8 d-flex flex-column" style="font-size: 0.875rem">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex">
                                    <div class="page-title mr-3" v-if="source && source.name">
                                        {{ source.name }}
                                    </div>

                                    <div v-if="source && source.url">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on"
                                                       :href="source.url"
                                                       target="_blank"
                                                       class="shadow-none bg-white">
                                                    <v-icon>open_in_new</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Voir sur Google</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-2" v-if="source && source.rating">
                                <div class="d-flex">
                                    <span class="mt-auto mb-auto mr-2">{{ source.rating }}</span>
                                    <div v-for="item in Math.floor(source.rating)" class="d-flex">
                                        <v-icon small color="warning">star</v-icon>
                                    </div>
                                    <div v-if="Math.floor(source.rating) !== source.rating">
                                        <v-icon small color="warning">star_half</v-icon>
                                    </div>
                                    <div v-for="item in 5 - Math.ceil(source.rating)">
                                        <v-icon small color="warning">star_border</v-icon>
                                    </div>
                                    <span class="mt-auto mb-auto ml-2">
                                        ({{ source.user_rating_count }})
                                    </span>
                                </div>
                            </div>
                            <div class="mb-2" v-if="source && source.google_category">
                                <span class="mt-auto mb-auto">{{ source.google_category }}</span>
                            </div>
                            <div class="mb-2" v-if="source && source.phone">
                                <v-icon color="blue" left>phone</v-icon>
                                <span class="mt-auto mb-auto">{{ source.phone }}</span>
                            </div>
                            <div class="mb-2" v-if="source && source.localisation && source.localisation.commune">
                                <v-icon color="blue" left>place</v-icon>
                                <span class="mt-auto mb-auto">
                                    {{ source.localisation.address }} , {{ source.localisation.postal_code }} {{ source.localisation.commune.name }}
                                </span>
                            </div>
                            <div class="mb-2" v-if="source && source.business_status !== 'OPERATIONAL'">
                                <v-icon color="blue" left>access_time</v-icon>
                                <span class="mt-auto mb-auto text-warning"
                                      v-if="source.business_status === 'CLOSED_TEMPORARILY'">
                                    Fermé temporairement
                                </span>
                                <span class="mt-auto mb-auto text-error"
                                      v-else-if="source.business_status === 'CLOSED_PERMANENTLY'">
                                    Fermé définitivement
                                </span>
                            </div>
<!--                            Score recherche GOOGLE pour test-->
<!--                            <div class="mb-2" v-if="source && source.searchingScore">-->
<!--                                <span class="mt-auto mb-auto">-->
<!--                                    Score de recherche Google: {{ source.searchingScore }}-->
<!--                                </span>-->
<!--                            </div>-->
<!--                                Score d'acceptation auto pour test-->
<!--                            <div class="mb-2" v-if="source && source.seuil">-->
<!--                                <span class="mt-auto mb-auto">-->
<!--                                    Score seuil déterminée: {{ source.seuil }}-->
<!--                                </span>-->
<!--                            </div>-->
                        </div>

                        <div class="col-4">
                            <v-img :src="source.media_cover.thumbnail_url"
                                   v-if="source && source.media_cover">
                            </v-img>
                            <v-img src="/images/empty_img.png" v-else>
                            </v-img>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>

export default {
    name: "VtSourceChoiceCard",
    props: ["source"],
}
</script>